import { BsBoxArrowRight } from 'react-icons/bs';
import Modal from '../Modals/Modal/Modal.jsx';
import { useState } from 'react';
import css from './LogOut.module.css';
import LogoutModal from '../Modals/LogoutModal/LogoutModal.jsx';
import useTooltip from '../../utils/useTooltip.jsx';
import Tooltip from '../sharedComponents/Tooltip/Tooltip.jsx';

export default function LogOut() {
  const [modalIsOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsTooltipVisible(false);
    setIsOpen(true);
  };

  const handleModalClose = () => {
    setIsOpen(false);
  };

  const {
    tooltipPosition,
    isTooltipVisible,
    setIsTooltipVisible,
    handleMouseEnter,
    handleMouseMove,
    handleMouseLeave,
    handleClick,
  } = useTooltip();

  return (
    <div
      className={css.tooltip}
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      <button className={css.btn} onClick={openModal}>
        <BsBoxArrowRight className={css.icon} />
      </button>
      {modalIsOpen && (
        <Modal isOpen={modalIsOpen} onClose={handleModalClose}>
          <LogoutModal onClose={handleModalClose} />
        </Modal>
      )}

      {isTooltipVisible && !modalIsOpen && (
        <Tooltip
          isVisible={isTooltipVisible}
          position={tooltipPosition}
          text="Вийти"
        />
      )}
    </div>
  );
}
